var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneySq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.138,
    height: 13.362,
    viewBox: "0 0 12.138 13.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money_sq",
    d: "M1.517,13.361A1.6,1.6,0,0,1,0,11.691V1.67A1.6,1.6,0,0,1,1.517,0h9.1a1.6,1.6,0,0,1,1.518,1.67V11.691a1.6,1.6,0,0,1-1.518,1.671Zm0-1.671h9.1V1.67h-9.1ZM5.31,10.02a.839.839,0,0,1,0-1.67H6.827a.839.839,0,0,1,0,1.67Zm0-2.5a.8.8,0,0,1-.759-.835A.8.8,0,0,1,5.31,5.85H6.827a.8.8,0,0,1,.758.835.8.8,0,0,1-.758.835Zm0-2.5a.8.8,0,0,1-.759-.836A.8.8,0,0,1,5.31,3.34H6.827a.8.8,0,0,1,.758.835.8.8,0,0,1-.758.836Z",
    transform: "translate(0.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySq);
export default __webpack_public_path__ + "static/media/money_sq.aa810c395903a4f0947937fcd84d3842.svg";
export { ForwardRef as ReactComponent };